import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

export const SKIP_LOADING_HEADER = 'X-Skip-Loading';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeCount = 0;

  constructor(private spinner: NgxSpinnerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(SKIP_LOADING_HEADER)) {
      const sanitized = request.clone({ headers: request.headers.delete(SKIP_LOADING_HEADER) });
      return next.handle(sanitized);
    }

    if (this.activeCount === 0) {
      this.spinner.show();
    }
    this.activeCount++;

    return next.handle(request).pipe(
      finalize(() => {
        this.activeCount--;
        if (this.activeCount <= 0) {
          this.activeCount = 0;
          this.spinner.hide();
        }
      })
    );
  }
}
